var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimeaiReferenceDataAmber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5c-1.6-1-3.6-1.5-5.5-1.5-.8 0-1.5.7-1.5 1.5v10.5c1.9 0 3.9.5 5.5 1.5v-12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5c1.6-1 3.6-1.5 5.5-1.5.8 0 1.5.7 1.5 1.5v10.5c-1.9 0-3.9.5-5.5 1.5v-12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimeaiReferenceDataAmber);
export default __webpack_public_path__ + "static/media/dimeai-reference-data-amber.64939c1d045d94f41244eced0db04e37.svg";
export { ForwardRef as ReactComponent };